import React from 'react';

const HamburgerIcon = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M20 17.2998C20.4999 17.2998 20.7996 17.5999 20.7998 18.0996C20.7998 18.5996 20.4 18.9004 20 18.9004H4C3.5 18.9004 3.2002 18.5996 3.2002 18.0996C3.20043 17.5999 3.60012 17.2998 4 17.2998H20ZM20 11.2998C20.4999 11.2998 20.7996 11.5999 20.7998 12.0996C20.7998 12.5996 20.4 12.9004 20 12.9004H4C3.5 12.9004 3.2002 12.5996 3.2002 12.0996C3.20043 11.5999 3.60012 11.2998 4 11.2998H20ZM20 5.2002C20.5 5.2002 20.7998 5.5 20.7998 6C20.7998 6.49997 20.4 6.7998 20 6.7998H4C3.50002 6.7998 3.20021 6.49997 3.2002 6C3.2002 5.5 3.6 5.2002 4 5.2002H20Z" fill="currentColor"/>
        </svg>
    )
}

export default HamburgerIcon;